import { HelFC } from '../../../interfaces';
import { AppPreloader } from '../AppPreloader';
import { MainContainer } from './MainContainer';
import { HeliosAppRoutes } from '../AppRoutes';

export const AppContainer:HelFC = () => <MainContainer preloader={AppPreloader} app={HeliosAppRoutes} />;
